import boletaApi from "./boletaApi";

export const updateEmployee = async (body) => {
  try {
    return await boletaApi.post("/updateEmployee", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
